import Preview from './Preview.vue'
import PreviewPopup from './PreviewPopup.vue'

export default {
    install(Vue) {
        Vue.component(Preview.name, Preview)
        Vue.component(PreviewPopup.name, PreviewPopup)
    }
}